import React from 'react';
import type { CSSProperties } from 'react';
import { Generation0Icon, Generation1Icon } from '../../icons';

import './RhythmScore.scss';

export interface RhythmScoreProps {
    score: number;
    generation: number;
}

// TODO: Determine if `score` should be a heading.
export function RhythmScore({ score, generation }: RhythmScoreProps) {
    const scoreLength = score.toString().length;

    // TODO: Consider a type to hold all of our custom properties,
    // and merge that with a new definition for CSSProperties.
    const cssVars: CSSProperties = {
        '--yat_rhythm-score-length': scoreLength,
    } as CSSProperties;

    const generationMarkup = generation === 0 ? <Generation0Icon /> : <Generation1Icon />;

    return (
        <div className="YatBadge-RhythmScore" style={cssVars}>
            <div className="YatBadge-RhythmScore-Interior">
                <div className="YatBadge-RhythmScore-Content">
                    <div className="YatBadge-RhythmScore-GenerationIcon">{generationMarkup}</div>
                    <span className="YatBadge-RhythmScore-RhythmScoreText">{score}</span>
                </div>
            </div>
        </div>
    );
}
